import { type OrderType, type OrderSource } from 'legacy/sections/orders/utils/orders.types'
import { type DateSelectRangeValueType } from 'legacy/dash-components/date-select-range/utils/dateSelectRange.types'
import { type RetailerLocationSelectValueType } from 'legacy/dash-components/retailer-location-select/utils/options.types'
import { dateToStringFormat } from 'legacy/common/utils/time/dateFormat'
import { type DateRange, dateRange } from 'legacy/common/utils/time/dateRanges.types'
import { compactNullObject } from 'utils/objects/compact'
import { type PerformanceMetricsApiResponse } from 'legacy/sections/analytics/components/performance-metrics/utils/performanceMetrics.types'
import instacart from 'legacy/common/instacart'

export interface PerformanceMetricsApiFetchDataProps {
  partnerId: string
  retailerId: string
  orderType?: OrderType
  orderSource?: OrderSource
  dateSelectRangeValue?: DateSelectRangeValueType
  retailerLocationSelectValue?: RetailerLocationSelectValueType
}

export interface FetchPerformanceDataQueryParams {
  timeRange?: DateRange
  startDate?: string
  endDate?: string
  order_type?: OrderType
  orderSource?: OrderSource
  store_group_id?: string
  retailer_location_ids?: ReadonlyArray<string>
}

// Sending a time range of "undefined" to the performance metrics API defaults to "Last Week"
// So we should default our DateRangeSelect to Last Week when no value is provided via the query params
export const PERFORMANCE_METRICS_API_DEFAULT_DATE_RANGE = dateRange.LAST_WEEK

export const performanceMetricsApiFetchData = ({
  partnerId,
  retailerId,
  orderType,
  orderSource,
  dateSelectRangeValue,
  retailerLocationSelectValue,
}: PerformanceMetricsApiFetchDataProps) => {
  const timeRange = (dateSelectRangeValue && dateSelectRangeValue.dateRange) || undefined
  const customDates = (dateSelectRangeValue && dateSelectRangeValue.customDates) || undefined
  const customStartDate = (customDates && customDates.startDate) || undefined
  const customEndDate = (customDates && customDates.endDate) || undefined
  const storeGroupId =
    (retailerLocationSelectValue && retailerLocationSelectValue.storeGroupId) || undefined
  const retailerLocationId =
    retailerLocationSelectValue && retailerLocationSelectValue.retailerLocationId

  const query = compactNullObject({
    orderSource,
    timeRange,
    startDate: customStartDate ? dateToStringFormat(customStartDate) : undefined,
    endDate: customEndDate ? dateToStringFormat(customEndDate) : undefined,
    order_type: orderType,
    store_group_id: storeGroupId,
    retailer_location_ids: retailerLocationId ? [retailerLocationId] : undefined,
  })

  return instacart.go.get<PerformanceMetricsApiResponse, FetchPerformanceDataQueryParams>(
    `/v1/partners/${partnerId}/warehouses/${retailerId}/performance`,
    {
      query,
    }
  )
}
